import { useMemo } from 'react';

export type FilterOption = { value: string; id?: string; label: string };

/**
 * Moves selected items to the top of the options list while keeping the
 * original relative order. Used by filter Selects to show checked items
 * first, mirroring the existing "selected + nonSelected" pattern reused
 * across OutgoingCalls, IncomingCalls, Dispensarization and Survey filters.
 */
export function useFilterOptions<T>(
  /** Source array — clinics, batches, enum tuples, etc. */
  items: T[],
  /** Currently selected values. */
  selectedValues: string[],
  /** Predicate: is this item currently selected? */
  isSelected: (item: T) => boolean,
  /** Maps an item to the {value, label} shape Ant Design expects. */
  toOption: (item: T) => FilterOption,
): FilterOption[] {
  return useMemo(() => {
    const selected: T[] = [];
    const rest: T[] = [];

    for (const item of items) {
      if (isSelected(item)) {
        selected.push(item);
      } else {
        rest.push(item);
      }
    }

    return [...selected, ...rest].map(toOption);
  }, [items, selectedValues]);
}
